import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Avatar from './Avatar';
import CardLabel from './CardLabel';
import CardTagLine from './CardTagLine';

export default class CompanyCard extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    location: PropTypes.string,
    description: PropTypes.string,
    url: PropTypes.string.isRequired,
    avatar: PropTypes.string,
    headline: PropTypes.string,
    tags: PropTypes.array,
    maxTags: PropTypes.number,
  };

  static defaultProps = {
    maxTags: 4,
    location: null,
    description: null,
    headline: null,
    avatar: null,
    tags: [],
  };

  renderDescription = () => {
    if (!this.props.description) {
      return;
    }
    return (
      <div class="u-mt-6">
        <span>{this.props.description}</span>
      </div>
    );
  };

  renderLocation = () => {
    if (!this.props.location) {
      return;
    }
    return (
      <div className="Card-detailInfo-location u-flex u-items-center u-mt-1">
        <span className="Card-detailInfo-icon">
          <i className="Icon Icon-map-marker" />
        </span>
        {this.props.location}
      </div>
    );
  };

  render() {
    return (
      <div
        className="Card-v2 Card-v2-padding CompanyCard"
        data-card-type="Company"
        data-card-title={this.props.name}>
        <div className="u-flex u-items-stretch">
          <Avatar
            src={this.props.avatar}
            href={this.props.url}
            name={this.props.full_name}
            type="company"
            className="u-w-16 md:u-w-36 u-h-16 md:u-h-36 u-text-4xl u-rounded Avatar--thin-initials"
          />
          <div className="u-flex-1 u-flex u-flex-col u-pl-4 md:u-pl-6">
            <div className="u-flex-1">
              <h5 className="u-text-lg u-m-0 u-leading-none">
                <a href={this.props.url}>{this.props.name}</a>
              </h5>
              <div className="u-text-grey u-text-sm u-mt-1 u-leading-normal">
                {this.props.headline}
                <div>Company</div>
              </div>
              <div className="u-mt-1 u-mb-2">{this.renderDescription()}</div>
            </div>
            <div className="u-flex-grow-0 md:u-block">
              {this.props.tags.length > 0 && (
                <CardTagLine
                  className="u-mt-2 md:u-mt-5"
                  seeMoreURL={this.props.url}
                  tags={this.props.tags}
                  maxTags={this.props.maxTags}
                  keyIdentifier={this.props.full_name}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
